'use client';

import { Code } from '@/sanity.types';
import { useEffect } from 'react';

interface DynamicScriptLoaderProps {
  js: Code;
}

const DynamicScriptLoader = ({ js }: DynamicScriptLoaderProps) => {
  useEffect(() => {
    // Only execute JavaScript if it exists
    if (!js || !js.code) {
      return;
    }

    // Delay execution to ensure DOM is fully rendered
    const timer = setTimeout(() => {
      try {
        console.log('Executing JavaScript from Sanity');

        // Create a new Function from the JavaScript code and execute it
        const executeScript = new Function(js.code as string);
        executeScript();
      } catch (error) {
        console.error('Error executing dynamic JavaScript:', error);
        console.error('JavaScript code that caused the error:', js.code);
      }
    }, 1000); // 1 second delay to ensure PageBuilder has rendered

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, [js]);

  // This component doesn't render anything visible
  return null;
};

export default DynamicScriptLoader;
